import db from "astrid-firebase/src/db";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import Actions from "../../../ui/components/Actions/Actions";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import useHasRight from "../../../authorization/hooks/useHasRight";

import PriceInfo from "./components/PriceInfo";
import PriceTargets from "./components/PriceTargets";

export default function PriceView({ id }) {
	const hasRight = useHasRight();

	const [price, loading, error] = useDocumentData(id && db.collection("prices").doc(id));

	return (
		<LoadingContext data={price} loading={loading} error={error}>
			{price && (
				<>
					<PriceInfo price={price} />

					{hasRight("prices.apply") && <PriceTargets price={price} />}

					<Actions data={price}>
						<Actions.ApprovalAction right="prices.approve" />
						<Actions.DeletionAction right="prices.delete" />
					</Actions>
				</>
			)}
		</LoadingContext>
	);
}
